import { render, staticRenderFns } from "./Crosshair.vue?vue&type=template&id=4b23d174&scoped=true&"
import script from "./Crosshair.vue?vue&type=script&lang=js&"
export * from "./Crosshair.vue?vue&type=script&lang=js&"
import style0 from "./Crosshair.vue?vue&type=style&index=0&id=4b23d174&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b23d174",
  null
  
)

export default component.exports